<div class="search-container-details">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">history</cll-icon>
        <span class="detail-table-title">History of reports</span>
    </div>
    <div>
        <button
            cll-icon-button
            cllSuffix>
            <cll-icon>search</cll-icon>
        </button>
    </div>
</div>

<div class="tabs-table-container">
    <table class="cll-table">
        <thead>
        <tr>
            <th>Report name</th>
            <th>Requested by</th>
            <th>Last requested</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
            <tr *ngFor="let report of testReportsHistoryData; let i = index">
                <td>{{ report.name }}</td>
                <td>{{ report.requested_by }}</td>
                <td>{{ report.last_requested }}</td>
                <td class="align-right">
                    <button cll-icon-button
                            [cllMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()">
                        <cll-icon>more_vert</cll-icon>
                    </button>

                    <ng-template #menu>
                        <cll-menu>
                            <button cllMenuItem>
                                <cll-icon type="outlined">open_in_new</cll-icon>
                                Open Report
                            </button>
                        </cll-menu>
                    </ng-template>
                </td>
              </tr>
        </tbody>
    </table>
</div>
